import styled from 'styled-components';
import Tag from './Tag';

const Container = styled.div`
  max-width: ${props => props.theme.spacing.maxWidth};
  margin: 0 auto;
`;

const SectionWrapper = styled.section`
  padding: 6rem 0;
  background: var(--color-background);
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
`;

const Column = styled.div`
  background: ${props => props.$dark ? props.theme.colors.dark.background : props.theme.colors.background};
  border-radius: ${props => props.theme.radii.card};
  padding: 3rem 3rem 18rem 3rem;
  color: ${props => props.$dark ? props.theme.colors.dark.text : props.theme.colors.text};
  border: ${props => props.theme.borders.widths.thin} solid;
  border-color: ${props => props.$dark ? props.theme.colors.text : props.theme.colors.secondary};
  position: relative;
  overflow: hidden;
`;

const Heading = styled.h2`
  font-size: 2.5rem;
  margin: 0.5rem 0 2rem;
  color: inherit;
`;

const SubHeading = styled.h3`
  ${props => props.theme.typography.heading};
  font-size: ${props => props.theme.typography.sizes.h4};
  margin-bottom: 1.5rem;
  color: inherit;
`;

const List = styled.ul`
  ${({ theme }) => theme.lists.bullet.style};
  margin: 0;
  
  li {
    margin-bottom: ${({ theme }) => theme.lists.bullet.spacing};
    font-size: ${({ theme }) => theme.lists.bullet.fontSize};
    line-height: ${({ theme }) => theme.lists.bullet.lineHeight};
  }
`;

const CircleInset = styled.div`
  position: absolute;
  left: -3rem;
  bottom: -3rem;
  height: 18rem;
  width: 18rem;
  border: ${props => props.theme.borders.widths.thin} solid;
  border-color: ${props => props.$dark ? props.theme.colors.text : props.theme.colors.secondary};
  border-radius: ${props => props.theme.radii.round};
  background-color: ${props => props.theme.colors.moogultint};
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    max-width: 80%;
    height: auto;
  }
`;

const Callout = styled.div`
  position: absolute;
  z-index: 1;
  left: 65%;
  bottom: 8rem;
  transform: translateX(-50%) rotate(-8deg);
  line-height: 1em;
  
  ${props => props.$dark ? `
    font-family: ${props.theme.typography.highlights.fontFamily};
    color: ${props.theme.colors.dark.text};
    font-size: 2.5rem;
    text-shadow: 0 5px 1px ${props.theme.colors.secondary};
  ` : `
    font-family: ${props.theme.typography.spooky.fontFamily};
    color: ${props.theme.colors.text};
    font-size: 3rem;
    text-shadow: 0 5px 1px ${props.theme.colors.brand};
  `}
`;

const FrankenbusinessSection = () => {
  return (
    <SectionWrapper>
      <Container>
        <Tag>WHY MOOGUL?</Tag>
        <Heading>Turn a 'Frankenbusiness' into<br />a well-oiled machine</Heading>
        
        <Grid>
          <Column>
            <Callout>IT'S ALIVE!!</Callout>
            <SubHeading>From energy-sapping disconnects...</SubHeading>
            <List>
              <li>Strategy stitched together across random documents</li>
              <li>Disconnects = lost opportunities</li>
              <li>Manual updates drain your energy</li>
              <li>Knowledge trapped in static files</li>
              <li>Constant reinvention of the wheel</li>
              <li>Slow and resource-intensive to adapt to changes</li>
            </List>
            <CircleInset>
              <img src="/assets/frankenbusiness.webp" alt="Frankenbusiness illustration" />
            </CircleInset>
          </Column>

          <Column $dark>
            <Callout $dark>IT'S SMART!!</Callout>
            <SubHeading>... to a swift and agile strategy</SubHeading>
            <List>
              <li>One integrated strategic system</li>
              <li>Greater efficiency and streamlining</li>
              <li>Human-led, AI-supported</li>
              <li>Flow seamlessly from strategy to action</li>
              <li>Evolve and grow your knowledge base</li>
              <li>Adapt fast to changing times or business pivots</li>
            </List>
            <CircleInset $dark>
              <img src="/assets/frankensmart.webp" alt="Smart business illustration" />
            </CircleInset>
          </Column>
        </Grid>
      </Container>
    </SectionWrapper>
  );
};

export default FrankenbusinessSection; 